import Image from 'next/image';
import { CSSProperties } from 'react';

import BigDiscountLogoInfo from '@assets/big-discount-info.svg';
import BigDiscountLogoWhite from '@assets/big-discount-white.svg';
import BigDiscountLogo from '@assets/big-discount.svg';

export function Big() {
    return <span aria-label='Big'>B.iG</span>;
}

export enum BigIconVariant {
    PRIMARY = 'primary',
    INFO = 'info',
    WHITE = 'white',
}
interface BigIconProps {
    height?: number;
    variant?: BigIconVariant;
    style?: CSSProperties;
}

export function BigIcon({ height = 16, variant = BigIconVariant.PRIMARY, ...props }: Readonly<BigIconProps>) {
    let image;
    switch (variant) {
        case BigIconVariant.INFO:
            image = BigDiscountLogoInfo;
            break;
        case BigIconVariant.WHITE:
            image = BigDiscountLogoWhite;
            break;
        case BigIconVariant.PRIMARY:
        default:
            image = BigDiscountLogo;
            break;
    }
    return <Image height={height} blurDataURL={image} src={image} alt='Big' priority {...props} />;
}
